<template>
    <div class="multiResponse-container" :class="{ multiResponse: selectedOptions.length > 0 }">
        <div class="selector-container" :class="[$mq, { answered: selectedOptions.length > 0 }]" @click="openPopup">
            <template v-if="selectedOptions.length">
                <div class="multi-value-list" :class="{ answered: selectedOptions.length > 0, 'is-folded': selectedOptions.length > 4 && !isExpanded }" :style="multiValueListStyle">
                    <div class="multi-value-item" v-for="item in selectedOptions" :key="item.v">
                        <span class="selector-color" :style="{ background: item.c }" :class="{ noColor: !item.c }"></span>
                        <span class="selector-item">{{ item.v }}</span>
                    </div>
                </div>
            </template>
            <div class="show-all" v-if="selectedOptions.length > 4 && !isExpanded" @click="openPopup">
                {{ $t('login.show_all') }}
            </div>
            <template v-else-if="selectedOptions.length === 0">
                <span class="selector-item" :class="[$mq]">
                    {{ translation('assets.selector_popup.title') }}
                </span>
            </template>
        </div>

        <div class="popup-container blocking popup-small" :class="[$mq]" v-if="isVisiblePopup">
            <div class="popup">
                <div class="list" :class="{ portrait: isApp || ['portrait'].includes($mq) }">
                    <SearchBar customClass="selector-popup" v-if="options.length >= 6" @on-search="filterOptions"></SearchBar>

                    <div class="item-list clear-value" @click="clearAll()">
                        {{ translation('assets.selector_popup.value-zero') }}
                    </div>

                    <div class="items-list" :class="{ 'mobile-landscape': isApp || ['portrait'].includes($mq) }">
                        <div class="item-list" v-for="item in filteredOptions" :key="item.v" :class="[{ selected: isSelected(item) }, { 'non-scroll': options.length < 6 }]" @click="toggleItem(item)">
                            <input type="checkbox" :checked="isSelected(item)" @change.stop="toggleItem(item)" />
                            <span class="custom-checkbox"></span>
                            <span class="selector-color" :style="{ background: item.c }" :class="[{ 'no-color': !item.c }]"></span>
                            <span class="selector-item">{{ item.v }}</span>
                        </div>
                    </div>
                </div>
                <div class="buttons-container">
                    <Button bType="confirm" customClass="multi-selector-popup" :bCallback="confirmSelection"></Button>
                    <Button bType="cancel" customClass="multi-selector-popup" :bCallback="closePopup"></Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchBar from '@/components/domain/ui/SearchBar.vue'
import Button from '@/components/domain/ui/Button.vue'
import i18n from '@/i18n'
import { displayPreventDeletePopup } from '@/utils/popups'

export default {
    components: {
        SearchBar,
        Button
    },
    name: 'MultiSelectorPopup',
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: undefined,
            default: null
        },
        canClicked: {
            type: undefined,
            default: true
        },
        itemHasActionPlan: {
            type: Boolean,
            default: false
        },
        isActionPlanPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedOptions: [],
            isVisiblePopup: false,
            filteredOptions: [],
            originalSelectedOptions: [],
            isExpanded: false
        }
    },
    computed: {
        isAuditItemInActionPlan() {
            return this.itemHasActionPlan && this.isActionPlanPage
        },
        isApp() {
            return this.$store.state.getIsApp
        },
        multiValueListStyle() {
            if (this.selectedOptions.length > 4 && !this.isExpanded) {
                return {
                    maxHeight: '198px'
                }
            }
            return {}
        },
        hasStoredValue() {
            return this.value !== null && this.value !== '' && this.value !== undefined
        }
    },
    methods: {
        openPopup() {
            this.$emit('openMultiselectPopup')

            if (this.canClicked === true && !this.isAuditItemInActionPlan) {
                this.isVisiblePopup = true
                this.$store.commit('setSelectPopup', true)
                this.originalSelectedOptions = [...this.selectedOptions]
            }
        },
        reopenPopup() {
            this.selectedOptions = [...this.originalSelectedOptions]
            this.filteredOptions = this.options
            this.isVisiblePopup = true
            this.$store.commit('setSelectPopup', true)
        },
        filterOptions(e) {
            const target = e.target.value
            this.filteredOptions = this.options.filter((item) => item.v.toLowerCase().includes(target.toLowerCase()))
        },
        load() {
            let valueArray = []
            if (typeof this.value === 'string') {
                valueArray = this.value.split('|').filter(Boolean)
            } else if (Array.isArray(this.value)) {
                valueArray = this.value
            }
            if (valueArray.length) {
                this.selectedOptions = this.options.filter((item) => valueArray.includes(item.v))
            } else {
                this.selectedOptions = []
            }
            this.filteredOptions = this.options
        },
        toggleItem(item) {
            const idx = this.selectedOptions.findIndex((i) => i.v === item.v)
            if (idx > -1) {
                this.selectedOptions.splice(idx, 1)
            } else {
                this.selectedOptions.push(item)
            }
        },
        isSelected(item) {
            return this.selectedOptions.some((i) => i.v === item.v)
        },
        clearAll() {
            if (this.selectedOptions.length == 0) {
                return
            }

            this.selectedOptions = []
        },
        async confirmSelection() {
            // mostrar popup de confirmación de borrar solo si antes el item aún tiene valor y ahora no hay ninguna opción seleccionada
            if (this.selectedOptions.length === 0 && this.hasStoredValue && !this.itemHasActionPlan) {
                this.isVisiblePopup = false
                const confirmed = await displayPreventDeletePopup(this)

                if (!confirmed) {
                    this.selectedOptions = [...this.originalSelectedOptions]
                    this.isVisiblePopup = true
                    return
                }
            }

            this.isVisiblePopup = false
            this.$store.commit('setSelectPopup', false)

            // early return para evitar que se llame al endpoint reset innecesariamente
            if (this.selectedOptions.length === 0 && !this.hasStoredValue) {
                return
            }

            const selectedValue = this.selectedOptions.length === 0 ? null : this.selectedOptions.map((i) => i.v).join('|')
            this.$emit('input', selectedValue)
        },
        closePopup() {
            this.isVisiblePopup = false
            this.selectedOptions = [...this.originalSelectedOptions]
            this.filteredOptions = this.options
            this.$store.commit('setSelectPopup', false)
        },
        translation(key) {
            return i18n.t(key)
        },
        isOldDate(date) {
            const today = new Date()
            const dateToCompare = new Date(date)
            return dateToCompare < today
        }
    },
    created() {
        this.load()
    },
    mounted() {},
    watch: {
        value() {
            this.load()
        },
        isVisiblePopup(newVal) {
            this.$emit('popup-status', newVal)
        }
    }
}
</script>

<style lang="scss" scoped>
.multiResponse-container {
    width: 100%;
    &.portrait {
        width: 100%;
    }
}
.multiResponse {
    width: 100%;
}
.selector-container {
    width: 100%;
    height: 100%;
    background-color: $color-selector;
    padding: 8px;
    padding-right: 26px;
    position: relative;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    @include border-radius(4px);
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 0.8em;
    &.answered {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .show-all {
            color: #384673;
            text-align: right;
            font-family: 'Avenir-Bold';
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: -0.42px;
        }
        &::after {
            top: 14px;
            color: #2d2e2f;
        }
    }
    .multi-value-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 2px;
        &.answered {
            gap: 8px;
            width: 100%;
        }
        .show-all {
            color: #384673;
            text-align: right;
            font-family: 'Avenir Next LT Pro';
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: -0.42px;
        }
    }
    .multi-value-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;
        border-radius: 4px;
        border: 1px solid var(--neutro-t-10-app, #e6e9ef);
        background-color: $neutro-light;
    }
    .selector-color {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-left: 0;
    }
    .selector-color.noColor {
        margin-left: 0;
        margin-right: 0 !important;
        @include background($color: $color-white, $image: img('noColor.svg'), $size: 11px);
    }

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        background: img('down_caret_aaaaaa.svg') no-repeat center;
        background-size: contain;
        width: 10px;
        height: 10px;
    }

    .selector-item {
        white-space-collapse: collapse;
        text-wrap: nowrap;
        min-height: 1.2em;
        color: $color-letter-selector;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        max-width: 93%;
        &.portrait {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 90%;
        }
        @media (max-width: 414px) {
            max-width: 80%;
        }
    }

    &.portrait {
        // width: 334px;
        width: 100%;
    }
}
.popup-container {
    .popup {
        width: 406px;
        // max-height: 740px;
        padding: 16px;
        border-radius: 4px;
        gap: 24px;
    }

    &.portrait {
        width: 334px;
        &.popup-small {
            .popup {
                width: 334px;
            }
            .buttons-container {
                width: 304px;
            }
            &.portrait {
                display: flex;
                align-items: center;
                .popup {
                    bottom: 0;
                }
            }
        }
    }
}
.list {
    width: 374px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;

    .cancel-btn {
        width: 100%;
        margin: 0px;
    }
    .item-list {
        padding: 8px;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        width: 100%;
        margin: 8px 0;
        border: 1px solid $color-neutral-300;
        @include border-radius(4px);
        transition: all 0.3s ease-in-out;

        &.non-scroll {
            width: 100%;
        }

        &:hover {
            background-color: $color-selector;
        }

        &.selected {
            background-color: $color-neutral-200;
        }

        &.clear-value {
            color: $color-letter-selector;
            width: 100%;
            height: 40px;
            font-size: 1.1em;
            padding: 8px 8px 8px 48px;
            margin: 16px 0 0 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            overflow-wrap: anywhere;
        }

        input[type='checkbox'] {
            opacity: 0;
            width: 0;
            height: 0;
            position: absolute;
        }

        .custom-checkbox {
            width: 13.824px;
            height: 13.824px;
            border: 1px solid $neutro-s50;
            border-radius: 4px;
            background: $color-white;
            display: inline-block;
            position: relative;
        }

        &.selected .custom-checkbox {
            border-color: $color-secondary-500;
            background-image: img('checkedbox.svg');
            width: 13.824px;
            height: 13.824px;
            background-color: $color-secondary-500;
        }
    }

    &.portrait {
        width: 302px;
        .clear-value {
            font-size: 0.8em;
        }
    }
    .items-list {
        max-height: 265px;
        overflow-y: auto;
        width: 100%;
        .item-list {
            height: 40px;
            margin: 16px 0;
            gap: 8px;
            display: flex;
            align-items: center;
        }
        &.mobile-landscape {
            max-height: 194px;
            .selector-item {
                max-width: 240px;
                font-size: 0.8em;
                min-height: 1.2em;
                color: $color-letter-selector;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                overflow-wrap: anywhere;
            }
        }
        .selector-color {
            padding: 5px;
            @include border-radius(100%);
            width: 9px;
            height: 9px;
            padding: 0;

            &.no-color {
                @include background($color: $color-white, $image: img('noColor.svg'), $size: 11px);
                border: 1px solid $color-selector2;
                position: relative;
            }
        }

        .selector-item {
            max-width: 240px;
            font-size: 1.1em;
            min-height: 1.2em;
            color: $color-letter-selector;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
.buttons-container {
    width: 374px;
    height: 84px;

    .content-button {
        padding: 0px !important;
        margin: 0px !important;
    }
}
.items-list .item-list:last-child {
    margin-bottom: 0 !important;
}
.multi-value-list.is-folded {
    max-height: 198px;
    overflow-y: hidden;
}
</style>
